<div class="card-header bg-success">
  <div class="row">
    <div class="col-md-6">
      <h3 class="text-white">Policy: {{ policyDetails?.policy_ref_number || policyDetails?.quote_ref_number || '—' }}</h3>
    </div>
    <div class="col-md-6">
      <div class="align-items-center justify-content-between float-right">
        <ul class="navbar-nav navbar-nav-right">
            <li class="nav-item nav-profile dropdown" *ngIf="policyDetails?.transaction_type == 1 || policyDetails?.transaction_type == 2 || policyDetails?.transaction_type == 3">
                <a 
                  class="nav-link dropdown-toggle p-0 text-white" 
                  href="#" 
                  data-toggle="dropdown"
                  id="profileDropdown"
                >
                  Actions
                </a>
                <div class="dropdown-menu dropdown-menu-right navbar-dropdown"
                    aria-labelledby="profileDropdown">
                    <a (click)="policyActions(3)" class="dropdown-item" >
                        <i class="mdi mdi-account-convert text-primary"></i>
                        Convert to MTA
                    </a>
                    <a (click)="policyActions(4)" class="dropdown-item" >
                        <i class="mdi mdi-delete-variant text-primary"></i>
                        Cancel
                    </a>
  
                </div>
            </li>
        </ul>
        <button class="navbar-toggler navbar-toggler-right d-lg-none align-self-center" type="button"
            data-toggle="horizontal-menu-toggle">
            <span class="mdi mdi-menu"></span>
        </button>
      </div>
    </div>
  </div>
</div>

<div class="card-body" *ngIf="loading">
  <p>Loading policy...</p>
</div>
<mat-tab-group class="float-left w-100" *ngIf="!loading && policyDetails?.id">
  <mat-tab>
    <ng-template mat-tab-label>Overview</ng-template>
    <div class="card-body">
      <app-equine-quote-overview [quoteDetails]="policyDetails"></app-equine-quote-overview>
    </div>
  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label>Full Details</ng-template>
    <div class="card-body">
      <app-equine-quote-full-details [quoteDetails]="policyDetails" [staticData]="staticData"></app-equine-quote-full-details>
    </div>
  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label>Financials</ng-template>
    <div class="card-body">
      <app-equine-quote-financials [quoteDetails]="policyDetails" [isBroker]="isBroker"></app-equine-quote-financials>
    </div>
  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label>Documents</ng-template>
    <div class="card-body">
      <app-equine-quote-documents [quote]="policyDetails"></app-equine-quote-documents>
    </div>
  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label>
        Claims
    </ng-template>
    <div class="card-body">
        <app-policy-claims [quote]="policyDetails"></app-policy-claims>
    </div>
  </mat-tab>
  <mat-tab *ngIf="!isBroker">
    <ng-template mat-tab-label>
        Payment
    </ng-template>
    <div class="card-body">
        <app-policy-payment [quote]="policyDetails" (quoteDetailsUpdated)="quoteDetailsUpdated($event)"></app-policy-payment>
    </div>
  </mat-tab>
  <mat-tab *ngIf="!isBroker">
    <ng-template mat-tab-label>
        PEP & Sanctions 
    </ng-template>
    <div class="card-body">
        <app-policy-compliance [quote]="policyDetails"></app-policy-compliance>
    </div>
  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label>
        Notes <span *ngIf="hasImportantNotes" class="ml-1" style="color: #ff0000" title="{{totalImpNotes}} Important Notes"><i class="mdi mdi-alert-circle"></i></span>
    </ng-template>
    <div class="card-body">
      <app-quote-notes [quote]="policyDetails" [isEquine] (hasImportantNotes)="onhasImportantNotesChange($event)"></app-quote-notes>
    </div>
  </mat-tab>
  <mat-tab *ngIf="isAdmin">
    <ng-template mat-tab-label>
        Email 
    </ng-template>
    <div class="card-body"> 
      <app-quote-email 
        (emailView)="getEmailView($event)" 
        (newEmailView)="newEmailView()"
        [quote]="policyDetails"
        *ngIf="!displayEmailView && !displayNewEmailView"></app-quote-email>
      <app-quote-email-view (backToEmailsList)="backToEmailsList()" [email_id]="email_id"  *ngIf="displayEmailView"></app-quote-email-view>
      <app-quote-email-compose (backToEmailsList)="backToEmailsList()" [quote]="policyDetails"  *ngIf="displayNewEmailView"></app-quote-email-compose>
    </div>
  </mat-tab>
</mat-tab-group>
<div class="card-body" *ngIf="!loading && !policyDetails?.id">
  <p class="text-muted">Policy not found.</p>
</div>
